<template>
  <div>
    <Modal v-for="modal in modals"
      v-bind:key="modal.key"
      v-bind:message="modal.message"
      v-bind:top="modal.top"
      v-bind:left="modal.left"
      v-on:click="modal.onClick"
      v-bind:class="{ shake: modal.shake }">
    </Modal>
    <div class="taskbar">
      <div class="start-button">
        <img src="@/assets/windows95.png" width="18" height="18" />
        <span>Start</span>
      </div>
      <div class="notifications">
        <span>{{ clicks }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from './Modal'

export default {
  name: 'Windows95',
  components: {
    Modal
  },
  data () {
    return {
      clicks: 0,
      modals: [{
        message: 'This site is under construction',
        onClick: this.handleClick,
        top: '50%',
        left: '50%',
        shake: false,
        key: this.clicks
      }]
    }
  },
  methods: {
    handleClick () {
      this.clicks++
      const top = this.getRandomNumber(25, 75)
      const left = this.getRandomNumber(25, 75)
      this.modals[0].top = top + '%'
      this.modals[0].left = left + '%'
      this.modals[0].shake = true
      this.modals[0].key = this.clicks
    },
    getRandomNumber (min, max) {
      return Math.random() * (max - min) + min
    }
  }
}
</script>
